import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from "../../config/constants";

const TeamSection = () => {
  const { t } = useTranslation('about');

  const teamMembers = [
    {
      name: "Lea Thijs",
      role: t('team.roles.ceo'),
      image: `${MEDIA_URL}/images/about/MEMBERS/Leaprofile.webp`,
    },
    {
      name: "Afonso Neto",
      role: t('team.roles.cofounder'),
      image: `${MEDIA_URL}/images/about/MEMBERS/Afonsoprofile.webp`,
    },
    {
      name: "Pixie",
      role: t('team.roles.customerRelation'),
      image: `${MEDIA_URL}/images/about/MEMBERS/Pixieprofile.webp`,
    },
  ];

  return (
    <section className="team-section">
      <div className="team-container">
        <h2 className="team-title">{t('team.title')}</h2>
        <div className="team-members">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member-card">
              <img
                src={member.image}
                alt={member.name}
                className="team-member-image"
              />
              <div className="team-member-info">
                <h3 className="team-member-name">{member.name}</h3>
                <p className="team-member-role">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
